// TradingViewWidget.jsx (수정 버전)
import React, { useEffect, useRef, memo } from 'react';

function MiniTradingView({ symbol = "AAPL" }) {
  const container = useRef();

  useEffect(
    () => {
      // 이미 위젯이 로드되어 있으면 중복 생성 방지
      if (container.current.children.length > 1) {
        return;
      }

      
      const script = document.createElement("script");
      script.src = "https://s3.tradingview.com/external-embedding/embed-widget-symbol-overview.js";
      script.type = "text/javascript";
      script.async = true;
      script.innerHTML = `
        {
          "lineWidth": 1,
          "lineType": 0,
          "chartType": "area",
          "fontColor": "rgb(106, 109, 120)",
          "gridLineColor": "rgba(46, 46, 46, 0.06)",
          "volumeUpColor": "rgba(34, 171, 148, 0.5)",
          "volumeDownColor": "rgba(247, 82, 95, 0.5)",
          "backgroundColor": "#ffffff",
          "widgetFontColor": "#0F0F0F",
          "upColor": "#22ab94",
          "downColor": "#f7525f",
          "borderUpColor": "#22ab94",
          "borderDownColor": "#f7525f",
          "wickUpColor": "#22ab94",
          "wickDownColor": "#f7525f",
          "colorTheme": "light",
          "isTransparent": false,
          "locale": "kr",
          "chartOnly": true,
          "scalePosition": "right",
          "scaleMode": "Normal",
          "fontFamily": "-apple-system, BlinkMacSystemFont, Trebuchet MS, Roboto, Ubuntu, sans-serif",
          "valuesTracking": "1",
          "changeMode": "price-and-percent",
          "symbols": [
            [
              "${symbol}|1D"
            ]
          ],
          "dateRanges": [
            "1d|1",
            "1m|30",
            "3m|60",
            "12m|1D",
            "60m|1W",
            "all|1M"
          ],
          "fontSize": "8",
          "headerFontSize": "medium",
          "autosize": true,
          "lineColor": "rgba(41, 98, 255, 0.5)",
          "topColor": "rgba(49, 121, 245, 0.5)",
          "bottomColor": "rgba(255, 255, 255, 0.14)",
          "width": "100%",
          "height": "100%",
          "noTimeScale": false,
          "hideDateRanges": false,
          "hideMarketStatus": false,
          "hideSymbolLogo": false
        }`;
      
      container.current.appendChild(script);

      // cleanup 함수로 컴포넌트 언마운트 시 스크립트 제거
      return () => {
        if (container.current) {
          // TradingView 위젯과 스크립트 태그들 모두 제거
          while (container.current.children.length > 1) {
            container.current.removeChild(container.current.lastChild);
          }
        }
      };
    },
    [symbol] // symbol이 변경될 때만 재실행
  );

  return (
    <div className="tradingview-widget-container" ref={container}>
      <div className="tradingview-widget-container__widget"></div>
      {/* <div className="tradingview-widget-copyright"><a href="https://kr.tradingview.com/" rel="noopener nofollow" target="_blank"><span className="blue-text">트레이딩뷰에서 모든 시장 추적</span></a></div> */}
    </div>
  );
}

export default memo(MiniTradingView);


